import { assertNever } from '@kofno/piper';
import { action, makeObservable, observable } from 'mobx';
import { ShareUrlError, State, creating, error, ready, waiting } from './Types';
import { ShareableLinksResource } from '../Types';

class CreateShareUrlStore {
  @observable
  state: State;

  constructor(learningCollectionResource: ShareableLinksResource) {
    makeObservable(this);
    this.state = waiting(learningCollectionResource);
  }

  @action
  ready = (learningCollectionResource: ShareableLinksResource) => {
    switch (this.state.kind) {
      case 'ready':
      case 'error':
        break;
      case 'waiting':
      case 'creating':
        this.state = ready(learningCollectionResource);
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  creating = () => {
    switch (this.state.kind) {
      case 'waiting':
      case 'ready':
        this.state = creating(this.state);
        break;
      case 'error':
      case 'creating':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  error = (err: ShareUrlError) => {
    switch (this.state.kind) {
      case 'waiting':
      case 'ready':
      case 'creating':
        this.state = error(err, this.state);
        break;
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };
}

export default CreateShareUrlStore;
